import { IGetSettings } from '@/contracts/modules/education/use-case/IGetSettings'
import { ISettings } from '@/contracts/modules/education/entities/ISettings'
import { GetSettingsRoute } from '@/modules/education/v1/api/v1/settings/GetSettings/GetSettingsRoute'

export class GetSettings implements IGetSettings {
  async exec(): Promise<ISettings> {
    const response = await new GetSettingsRoute().exec(null)
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData()
  }
}
